import { cn } from "@app/lib/utils";
import { trans } from "@mongez/localization";
import { sectorsData } from "../data/sectorsData";
import { SectorCard } from "./SectorCard";
import { TheSectorsSectionBG } from "./TheSectorsSectionBG";

/**
 * Subsidiary section component
 * Displays sectors in a responsive layout with background animation
 */
export function SubsidiarySection() {
  return (
    <div className="relative overflow-hidden">
      <TheSectorsSectionBG />

      <div
        className={cn(
          "container relative z-10",
          "space-y-8 sm:space-y-10 md:space-y-16",
          "py-10 pt-16 sm:pb-16 sm:pt-20 lg:py-24",
        )}
      >
        <h4
          className={cn(
            "font-semibold tracking-[-0.03rem] text-white",
            "text-2xl sm:text-3xl md:text-4xl 3xl:text-5xl",
          )}
        >
          {trans("aboutUsPage.leadership.subsidiaries.sectorsTitle")}
        </h4>

        {/* Mobile: Stack cards vertically, Desktop: Horizontal scroll */}
        <div
          className={cn(
            "w-full grid-cols-4 max-2xl:grid-cols-2 max-sm:grid-cols-1",
            "grid place-items-center",
            "gap-4 sm:gap-5 md:overflow-x-auto md:pb-4",
          )}
        >
          {sectorsData.map((sector, index) => (
            <SectorCard key={index} sector={sector} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}
